import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Loader from "../../../components/Common/Loader";
import useMoveHistory from "../Hooks/useMoveHistory";
import moment from "moment";
import { useTranslation } from "react-i18next";

export default function MoveStateHistory({ initValue: { moveId } }) {
    const { t } = useTranslation();
    const [history, isLoading] = useMoveHistory({ moveId });

    const columns = [
        {
            text: t('commons.date'), headerStyle: { width: '3rem' },
            formatter: function (_cell, row, rowIndex) {
                return moment(row.executionDate).format("DD/MM/YYYY HH:mm");
            }
        },
        { dataField: 'user.fullName', text: t('commons.user'), headerStyle: { width: '3rem' } },
        {
            text: t('inventory.commons.previousState'), headerStyle: { width: '3rem' }
            , formatter: (cell, row) => row?.previousStatus != null && row?.previousStatus?.trim() != ''
                ? t(`inventory.movements.moveState.${row?.previousStatus.toLowerCase()}`)
                : " - "
        },
        {
            text: t('inventory.commons.currentState'), headerStyle: { width: '3rem' }
            , formatter: (cell, row) => row?.nextStatus != null && row?.nextStatus?.trim() != ''
                ? t(`inventory.movements.moveState.${row?.nextStatus.toLowerCase()}`)
                : " - "
        },
        { dataField: 'comment', text: t('commons.comment'), headerStyle: { width: '7rem' } }
    ]

    return (<Loader isLoading={isLoading}>
        <BootstrapTable
            bordered={false}
            hover
            remote
            condensed
            keyField='id'
            classes="table-spaced table-spaced-small"
            wrapperClasses="table-responsive"

            onTableChange={() => { }}

            data={history}
            columns={columns}
            loading={isLoading}
            noDataIndication={() => <>{t("commons.noData")}</>}
        />
    </Loader>)

}